export default "__VITE_ASSET__Bv468CfU__"